import { convertRowsToData } from '../utils/dataUtils'
export default function ChoroplethDataController(rows, config) {
  let propperHeaders = ['id', config.ItemsHelper.colorKey, 'label', 'year']
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 1)

  return config.features.map((feature, i) => {
    let candidate = data.find(d => d.id === feature.properties[config.featureIdProperty])
    let result = {
      id: feature.properties[config.featureIdProperty],
      label: '', // feature.properties[config.featureLabelProperty],
    }

    if (candidate) {
      result[config.ItemsHelper.colorKey] = candidate[config.ItemsHelper.colorKey]
      result.label = candidate.label || result.label
      result.year = candidate.year || '?'
    }

    return result
  })
}
